/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import { useEffect } from "react"
import Header from "../layout/header"
import Footer from "../layout/footer"
import BlockContent from "@sanity/block-content-to-react"
import Serializers from "./serializers/serializers"
import SearchResults from "../components/searchResults"
import Container from "../components/container"
import Hero from "../layout/Hero"
const LayoutSearch = home => {
  // Clear localStorage BEFORE any children mount (must be synchronous)
  if (typeof window !== "undefined") {
    localStorage.removeItem("query")
    localStorage.removeItem("searchState")
  }

  const data = useStaticQuery(graphql`
    query SiteSearchTitleQuery {
      site: site {
        siteMetadata {
          title
        }
      }
      blockFragment: sanityPageDefinition(slug: { current: { eq: "home" } }) {
        _rawEntities(resolveReferences: { maxDepth: 10 })
        _rawHero(resolveReferences: { maxDepth: 10 })
      }
    }
  `)

  // Handle Safari bfcache (back-forward cache) restoration
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page was restored from bfcache - reload to clear stale search state
        window.location.reload()
      }
    }

    window.addEventListener("pageshow", handlePageShow)

    return () => {
      window.removeEventListener("pageshow", handlePageShow)
    }
  }, [])

  return (
    <div
      sx={{
        fontFamily: "body",
        fontWeight: "body",
        fontSize: "2",
        lineHeight: "body",
        h1: {
          fontFamily: "heading",
          fontWeight: "heading",
          lineHeight: "heading",
        },
        h2: {
          fontFamily: "heading",
          fontWeight: "heading",
          lineHeight: "heading",
          fontSize: "6",
        },
      }}
    >
      <h2 style={{ display: "none" }}>Search Items</h2>
      <div>
        <Hero node={data.blockFragment}></Hero>
      </div>
      <SearchResults />

      <Footer></Footer>
    </div>
  )
}

export default LayoutSearch
